module.exports = __webpack_public_path__ + "img/c_sv3.f9aa923.png";